module.exports = __webpack_public_path__ + "static/media/teamicon.99432c7d.svg";